import React from 'react'
import { Space, Button, Popconfirm, Typography } from 'antd'
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons'

const { Text } = Typography

interface BulkActionsBarProps {
    selectedCount: number
    onBulkDelete: () => void
    onClearSelection: () => void
    itemType: string
}

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
    selectedCount,
    onBulkDelete,
    onClearSelection,
    itemType,
}) => {
    if (selectedCount === 0) return null

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                background: 'linear-gradient(135deg, #fff7e6 0%, #fff1f0 100%)',
                borderRadius: '8px',
                marginBottom: '16px',
                border: '1px solid #ffd591',
            }}
        >
            <Space>
                <ExclamationCircleOutlined style={{ color: '#fa8c16', fontSize: '16px' }} />
                <Text strong>
                    {selectedCount} {itemType}
                    {selectedCount > 1 ? 's' : ''} selected
                </Text>
            </Space>

            <Space>
                <Button size="small" onClick={onClearSelection}>
                    Clear Selection
                </Button>
                <Popconfirm
                    title={`Delete ${selectedCount} ${itemType}${selectedCount > 1 ? 's' : ''}?`}
                    description="This action cannot be undone. All selected items will be permanently deleted."
                    onConfirm={onBulkDelete}
                    okText="Delete All"
                    cancelText="Cancel"
                    okButtonProps={{ danger: true }}
                >
                    <Button danger size="small" icon={<DeleteOutlined />}>
                        Delete Selected
                    </Button>
                </Popconfirm>
            </Space>
        </div>
    )
}
